/**
 * @fileoverview Acctions para la gestión y carga de equipos (teams) en el inbox.
 * Provides functions to get, set and handle errors of teams using the TeamModelMC model.
 * @module actions/inbox/teamActions
 * @category Actions Layer
 * @since 2.0.0
 * @version 3.1.0
 */

/**
 * @typedef {Object} Team
 * @description Data structure for a team.
 * @property {string|number} id - Unique identifier for the team.
 * @property {string} name - Name of the team.
 * @property {Array<Object>} [members] - Members of the team.
 * @property {boolean} [active] - Activity status of the team.
 */
import TeamModelMC from '../../presentation/models/TeamModelMC';
import { TEAMS_ACTIONS } from '../../constants/actionsConstants';

/**
 * Asynchronous action to get teams only if the array is empty and not loading.
 *
 * @function getTeamsIfEmpty
 * @category Actions Layer
 * @param {Object} params - Parameters for the query of teams.
 * @returns {Promise<void>} No returns value, only dispatches actions.
 * @example
 * await getTeamsIfEmpty({ active: true })(dispatch, getState);
 * @see {@link TeamModelMC.getAllForInbox}
 */
const getTeamsIfEmpty = (params) => async (dispatch, getState) => {
  const { teams, loading } = getState().inboxTeamsReducer;
  if (loading) return;
  if (!teams?.length) {
    dispatch({ type: TEAMS_ACTIONS.TEAMS_LOADING_START });
    try {
      const responseTeams = await TeamModelMC.getAllForInbox(params);
      dispatch({ type: TEAMS_ACTIONS.SET_ALL_TEAMS, data: responseTeams });
    } catch (err) {
      dispatch({ type: TEAMS_ACTIONS.TEAMS_LOADING_ERROR, error: err.message || 'Error loading teams' });
    }
  } else {
    dispatch({ type: TEAMS_ACTIONS.TEAMS_ALREADY_LOADED });
  }
};

export default getTeamsIfEmpty;
